import React, { useState, useEffect } from "react";
import axios from 'axios';
import { RotatingLines } from 'react-loader-spinner';
import { useNavigate, useParams } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import Select from "react-select";
import 'react-toastify/dist/ReactToastify.css';
function NewCustomerEdit() {

    const [loading, setLoading] = useState(true);
    const [duration, setDuration] = useState({});
    const [availStb, setAvailStb] = useState(true);
    const [status, setStatus] = useState("");
    const [inpStb, setInpStb] = useState("");
    const [network, setNetwork] = useState("");
  
    const [detail, setDetail] = useState([]);
    const [options, setOptions] = useState([]);
    const [street, setStreet] = useState([]);
    const [stb, setstb] = useState([]);
   
    const navigate = useNavigate();
    const [method, setMethod] = useState('');
    const [selectedOptions, setSelectedOptions] = useState([]);
 const [balance, setBalance] = useState(0);
    const [secret, setSecret] = useState('');
    const [paidDate, setPaidDate] = useState('');
    const [paidTime, setPaidTime] = useState('');
    const [ColBoy, setColBoy] = useState('');
    const [Code, setCode] = useState('');
  const [box, setBox] = useState(true);
     const [boxSave, setBoxSave] = useState("");
     const [staff, setStaff] = useState({});
     const [staffs, setStaffs] = useState({});
     const [Stb, setStb] = useState(true);
     const [oldStb, setOldStb] = useState(null);
     const [oldData, setOldData] = useState([]);
     const [stbError, setStbError] = useState(null);
     const [error, setError] = useState(null);
     const [EditCustomer, setEditCustomer] = useState({});
      const [tripsheet, settripsheet] = useState({});
     const [streetName, setStreetName] = useState([]);
     const [group, setGroup] = useState("");
     const [replacement, setReplacement] = useState("");
     const [incentive, setIncentive] = useState("");
     const [installed, setInstalled] = useState("");
    const [remark, setRemark] = useState('');
     const [pack, setPackage] = useState([]);
       const [paidAmt, setpaidAmt] = useState(0);
            const [ExtrapaidAmt, setExtrapaidAmt] = useState(0);
              const [payAmt, setPayamt] = useState(0);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const { id } = useParams();

    const user = getCookie('user');
    function getCookie(name) {
        const cookies = document.cookie.split('; ');
        for (const cookie of cookies) {
            const [key, value] = cookie.split('=');
            if (key === name) { return value; }
        } return null;
    }
    function details(event) {
        setDetail((event.target.value).split("-"))

    }
    function stbVerify(e) {
        if (inpStb.includes(" ")) {
            toast.warning("do not contain space")
            return
        }
        const selectedStreet = stb.find(t => t.serial_num === inpStb);
        if (selectedStreet) {
            setAvailStb(true);
            toast.warning("STB num not available !")
            setInpStb("");

        } else {
            setAvailStb(false);
            toast.success("STb available")


        }
    }
    function durationChange(e) {
        if (e.name && e.value) {
            setDuration((prev) => ({
                ...prev,
                [e.name]: e.value,
            }));
        } else if (e.target) {
            const { name, value } = e.target;
            setDuration((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    }
    useEffect(() => { if (!user) { navigate('/login') } }, [user, navigate]);
    useEffect(() => {
        setDuration((prev) => ({
            ...prev,
            connectionStatus: "Active", // or your desired default
        }));
    }, []);
    useEffect(() => {
        if (method === "new_connection" || method === "shift_connection") {
            setDuration(prev => ({
                ...prev,
                monthPaid: prev.monthPaid || 1
            }));
        }
    }, [method]);

    async function fetchData() {
        try {
            const response = await axios.post('https://node.cabletvpay.in/addCustomerNeeds', { user });
            if (response.status === 200) {
                console.log(response.data);
                setGroup(response.data.group);
                setstb(response.data.stb);
                setStreet(response.data.street);
                setOptions((response.data.staff).map((item) => ({
                    value: item.area_code,
                    label: item.name,
                })));
                setStaff(response.data.staff);
            }
        } catch (error) {
            setError(error.response?.data?.message || "Error fetching data");
            console.log(error);
        } finally {
            setLoading(false);
        }

    }
        const fetchUserData = async () => {
            try {
                const response = await axios.post('https://node.cabletvpay.in/EditCustomerGetInfo', { user, id });
                if (response.status === 200) {
                    console.log(response.data);
                    setStreetName(response.data.street);
                    setGroup(response.data.group);
                    setEditCustomer(response.data.EditCustomer[0]);
                    setPackage(response.data.package);
                    setBox(response.data.box);
                    setStaff((response.data.staff).map((item, a) => ({ value: item.area_code, label: item.name, })));
                    setStaffs(response.data.staff);
                    setStb(response.data.newStb);
                    setOldStb(response.data.EditCustomer[0].serial_num);
                    setpaidAmt(Number(response.data.EditCustomer[0].paid_amt));
                     setExtrapaidAmt(Number(response.data.EditCustomer[0].extra_balance_amt));
                    setBalance(Number(response.data.EditCustomer[0].balance_amt));
                    setSecret(response.data.EditCustomer[0].secret_id);
                    setPayamt(response.data.EditCustomer[0].pay_amt);
                  
                    setPaidDate(response.data.EditCustomer[0].paid_date);
                    setPaidTime(response.data.EditCustomer[0].paid_time);
                    setColBoy(response.data.EditCustomer[0].col_boy);
                    setCode(response.data.EditCustomer[0].carea_code);
                    setStatus(response.data.EditCustomer[0].status);
                    setOldData(JSON.parse(JSON.stringify(response.data.EditCustomer[0])));
                    settripsheet(response.data.tripsheet);
                    console.log("response", response.data.EditCustomer[0]);
                }
            } catch (err) {
                setError(err.response?.data?.message || "Error fetching data");
                console.log(err);
            } finally { setLoading(false); }
        };
    useEffect(() => {
        let statusValue = "";
        if (method === "free") {
            statusValue = "free";
        } else if (method === "re_connection") {
            statusValue = "unpaid";
        } else if (method === "new_connection" || method === "shift_connection") {
            statusValue = "paid";
        }

        setStatus(statusValue);
        setDuration((prev) => ({
            ...prev,
            Status: statusValue,
        }));
    }, [method]);


    function handleSubmit(e) {
        e.preventDefault();

        if (inpStb.trim() === "" || inpStb.includes(" ")) {
            toast.warning("only valid STB numbers accepted");
            return;
        }

        const data = {
            user,
            method,
            inpStb,
            ...duration
        };
    }


    async function confirmSubmit(e) {
        e.preventDefault();

        if (isSubmitting) return; // 🛑 block multiple clicks
        setIsSubmitting(true);

        try {
            const response = await axios.post(
                'https://node.cabletvpay.in/submitAddCustomer',
                { user, method, detail, duration, inpStb }
            );
            if (response.status === 200) {
                toast.success("Customer Added successfully!");
                navigate("/allCustomer/all", {
                    state: { customerId: response.data.customer_id }
                });
            }
        } catch (err) {
            toast.error(err.response?.data?.message || "error adding customer");
            setIsSubmitting(false); // re-enable if failed
        }
    }


    useEffect(() => {
        fetchData()
        fetchUserData()
    }, [user])


    if (loading) {
        return (<div className="content-wrapper"><div className="d-flex justify-content-center align-items-center" style={{ height: "80vh" }}>  <RotatingLines visible={true} height="80" width="80" strokeColor="#007bff" strokeWidth="2" animationDuration="3" />  </div>  </div>);
    }

    if (error) {
        return (<div className="content-wrapper"><div className="d-flex justify-content-center align-items-center" style={{ height: "73vh" }}>  <img src="../asset/img/errorPage.jpg" alt="Error" style={{ height: "20rem" }} />  </div>  </div>);
    }
    return (
        <div className="content-wrapper">
            <div className="container-fluid">
                <div className="content-header pt-1 ">
                    <div className="mt-3 border-bottom">
                        <div className="fs-4 valuesDec h5">Edit CUSTOMER</div>
                        <ToastContainer theme='dark' />
                    </div>
                    <div className="mx-1 p-1 border-0 mt-3" >
                        <form onSubmit={handleSubmit}>
                            <div className="row  my-0" >
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="d-flex justify-content-around">
                                        <div className="input-group">
                                            <label htmlFor="stbNumber" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>STB number : <span className={availStb ? 'text-danger' : 'text-success'}>{availStb === true ? "Not Available" : availStb === false ? "STB available" : ""}</span> </label>
                                            <div className="input-group elevation-3 rounded">
                                                <input type="text" name="stbNumber" id="stbNumber" className="form-control bg-gradient-light text-navy border-dark border-width-2 input-group" value={EditCustomer.serial_num} placeholder="enter new STB" aria-describedby="basic-addon2" onChange={(e) => { setInpStb(e.target.value) }} />
                                                <div className="input-group-append">
                                                    <button type="button" className="btn bg-navy btn-group" name="verify" id="verify" onClick={stbVerify} >Verify</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="form-group">
                                        <label htmlFor="customerName" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>customer name :</label>
                                        <input type="text" name="customerName" id="customerName" className="form-control text-navy border-dark elevation-3" value={EditCustomer.name} onChange={durationChange} placeholder="enter name here" required />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="form-group">
                                        <label htmlFor="boxType" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>box model/type :</label>
                                        <input type="text" name="boxType" id="boxType" className="form-control text-navy border-dark elevation-3" value={tripsheet?.[0]?.box_type || ""} onChange={durationChange} placeholder="enter box type" required />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="form-group">
                                        <label htmlFor="accountNumber" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>account number :</label>
                                        <input type="text" name="accountNumber" id="accountNumber" className="form-control text-navy border-dark elevation-3" value={EditCustomer.account_num} onChange={durationChange} placeholder="enter account number" />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="form-group">
                                        <label htmlFor="customerGroup" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>customer Group :</label>
                                        <select className="form-control text-navy border-dark elevation-3" onChange={durationChange} value={EditCustomer.group} id="customerGroup" name="customerGroup">
                                            <option value="">none</option>
                                            {group.length > 0 ? (
                                                group.map((row, index) => (
                                                    <option key={index} value={row.group_name}>{row.group_name}</option>
                                                ))
                                            ) : (<option value="">group unavailable</option>)}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="form-group">
                                        <label htmlFor="boxAmount" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>box amount :</label>
                                        <input type="text" name="boxAmount" id="boxAmount" className="form-control text-navy border-dark elevation-3" value={tripsheet?.[0]?.box_amount || ""} onChange={durationChange} placeholder="enter box  amount" required />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="form-group">
                                        <label htmlFor="street" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>Street :</label>
                                     <select
  className="form-control text-navy border-dark elevation-3"
  id="street"
  name="street"
  value={EditCustomer?.street || ""}
  onChange={details}
>
                                            <option value="none">none</option>
                                            {
                                                street.length > 0 ? (
                                                    street.map((row, index) => (
                                                        <option key={index} value={`${row.street_name}-${row.network_name}-${row.executive_name}-${row.area_code}`}>{row.street_name}</option>
                                                    ))
                                                ) : (<option value="none">none</option>)
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="form-group">
                                        <label htmlFor="flatName" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>Flat name :</label>
                                        <input type="text" name="flatName" id="flatName" className="form-control text-navy border-dark elevation-3" onChange={durationChange} value={EditCustomer.flat} placeholder="enter flat name" />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="form-group">
                                        <label htmlFor="installationAmount" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>installation amount :</label>
                                        <input type="text" name="installationAmount" id="installationAmount" className="form-control text-navy border-dark elevation-3" value={tripsheet?.[0]?.insulation || ""} placeholder="enter installation amount" onChange={durationChange} required />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="form-group">
                                        <label htmlFor="networkName" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>network name :</label>
                                        <select className="form-control text-navy border-dark elevation-3" id="networkName" name="networkName" onChange={durationChange} value={EditCustomer.net_name} >
                                            <option value={detail[1]}>{detail[1]}</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="form-group">
                                        <label htmlFor="mobileNumber" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>mobile number :</label>
                                        <input type="number" name="mobileNumber" id="mobileNumber" className="form-control text-navy border-dark elevation-3" value={EditCustomer.mobile} placeholder="enter phone number" onChange={durationChange} required />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="form-group">
                                        <label htmlFor="Incentive" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>Incentive Amount :</label>
                                        <input type="text" name="Incentive" id="Incentive" className="form-control text-navy border-dark elevation-3" placeholder="enter phone number" value={tripsheet?.[0]?.incentive || ""} onChange={durationChange} required />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="form-group">
                                        <label htmlFor="doorNo" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>door number :</label>
                                        <input type="text" name="doorNo" id="doorNo" className="form-control text-navy border-dark elevation-3" placeholder="enter door number" value={EditCustomer.door} onChange={durationChange} />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="form-group">
                                        <label htmlFor="alternateMobileNumber" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>alternate mobile number :</label>
                                        <input type="number" name="alternateMobileNumber" id="alternateMobileNumber" className="form-control text-navy border-dark elevation-3" value={EditCustomer.alternative_mobile} placeholder="enter alternate mobile number" onChange={durationChange} />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="form-group">
                                        <label htmlFor="packageAmount" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>package amount <span className="text-success">(default)</span> :</label>
                                        <input type="number" name="packageAmount" id="packageAmount" className="form-control text-navy border-dark elevation-3" value={EditCustomer.pay_amt} placeholder="enter package amount" onChange={durationChange} required />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="form-group">
                                        <label htmlFor="status" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>status :</label>
                                        <input
                                            type="text"
                                            name="Status"
                                            id="Status"
                                            className="form-control text-navy border-dark elevation-3"
                                            disabled
                                           value={EditCustomer.status}
                                           
                                        />

                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="form-group">
                                        <label htmlFor="package" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>package :</label>
                                        <input type="text" name="package" id="package" className="form-control text-navy border-dark elevation-3" placeholder="enter package" value={EditCustomer.package} onChange={durationChange} required />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="form-group">
                                        <label htmlFor="discountAmount" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>discount amount :</label>
                                        <input type="number" name="discountAmount" id="discountAmount" className="form-control text-navy border-dark elevation-3" placeholder="enter discount amount" value={EditCustomer.discount} onChange={durationChange} />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="form-group">
                                        <label htmlFor="connectionStatus" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>connection status :</label>
                                        <select
                                            className="form-control text-navy border-dark elevation-3"
                                            id="connectionStatus"
                                            name="connectionStatus"
                                            value={duration.connectionStatus || "Active"}
                                            onChange={durationChange}
                                           
                                        >
                                            <option value="Active">Active</option>
                                            <option value="Deactive">Deactive</option>
                                        </select>

                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="form-group">
                                        <label htmlFor="staffCode" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>staff code :</label>
                                        <select className="form-control text-navy border-dark elevation-3" id="staffCode" name="staffCode" rvalue={EditCustomer.area_code} equired>
                                            {
                                                detail[2] ? (
                                                    <option value={`${detail[2]}|${detail[3]}`}>{`${detail[2]} |(${detail[3]})`}</option>
                                                ) : (
                                                    <option value="">none</option>
                                                )
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="form-group">
                                        <label htmlFor="CmonthBalance" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>current month balance amount :</label>
                                        <input type="number" name="CmonthBalance" id="CmonthBalance" className="form-control text-navy border-dark elevation-3" placeholder="enter current month balance amount" onChange={durationChange} required />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="form-group">
                                        <label htmlFor="installedBy" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>Installed By :</label>
                                        <Select
                                            options={options}
                                            isMulti
                                            value={selectedOptions}
                                            onChange={(selected) => {
                                                setSelectedOptions(selected);
                                                durationChange({ name: "selectedOptions", value: selected }); // Pass as an object to match other inputs
                                            }}
                                            placeholder="Select an Option"
                                            className="text-navy border-dark elevation-3"
                                            classNamePrefix="select"

                                        />                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="form-group">
                                        <label htmlFor="monthPaid" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>No of Month Paid <span className="text-orange">( Choose Advance Amount )</span> :</label>
                                        <input
                                            type="number"
                                            name="monthPaid"
                                            id="monthPaid"
                                            className="form-control text-navy border-dark elevation-3"
                                            value={duration.monthPaid ?? 1}
                                            onChange={durationChange}

                                            required
                                        />

                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="form-group">
                                        <label htmlFor="amountCollectedBy" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>Amount Collected By :</label>
                                        <select
                                            className="form-control text-navy border-dark elevation-3"

                                            id="amountCollectedBy"
                                            name="amountCollectedBy"
                                            value={duration.amountCollectedBy || ""}  // ✅ make it controlled
                                            onChange={durationChange} required
                                        >
                                            <option value="">none</option>
                                            {staff.length > 0 ? (
                                                staff.map((row, i) => (
                                                    <option key={i} value={`${row.name}`}>
                                                        {`${row.name} - (${row.area_code})`}
                                                    </option>
                                                ))
                                            ) : (
                                                <option value="">No options available</option>
                                            )}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="form-group">
                                        <label htmlFor="amountCollectedBy" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>Previous Month Pending Amount :</label>
                                        <input type="number" name="pendingAmount" id="pendingAmount" className="form-control text-navy border-dark elevation-3" placeholder="enter Previous Month Pending Amount" onChange={durationChange} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="text-center mt-4">
                                    <input
                                        type="submit"
                                        value="Submit"
                                        className="btn btn-success p-2 text-bold elevation-2"

                                    />
                                </div>
                            </div>
                        </form>


                    </div>


                </div>
            </div >
        </div >
    );
}
export default NewCustomerEdit;

